module.exports = __webpack_public_path__ + "static/media/west-vesey.30176dab.svg";